import React, { Component } from 'react';
import Highcharts from "highcharts";
import PropTypes from 'prop-types';

import { MainGraph, ContainerInsideChart, StyledHighChart, BackgroundContainer } from './styles'; // AVGContainer
// eslint-disable-next-line no-undef
require('highcharts/highcharts-more')(Highcharts);
// eslint-disable-next-line no-undef
require('highcharts/modules/solid-gauge')(Highcharts);

class HighchartComponent extends Component {

  componentDidMount() {
    const { payload, id } = this.props;
    new Highcharts.chart({
      chart: {
        type: 'solidgauge',
        renderTo: id,
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },

      title: null,

      credits: {
        enabled: false
      },

      tooltip: {
        enabled: false
      },

      pane: {
        startAngle: -150,
        endAngle: 150,
        background: [{
          outerRadius: '136%',
          innerRadius: '115%',
          backgroundColor: '#1E6481' || Highcharts.Color(Highcharts.getOptions().colors[0])
            .setOpacity(0.3)
            .get(),
          borderWidth: 0,
          shape: "arc"
        }],
      },

      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: []
      },

      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false
          },
          linecap: 'round',
          stickyTracking: false,
          rounded: parseFloat(payload.steps) > 0
        }
      },

      series: [{
        name: 'Move',
        data: [{
          color: '#42e3f5',
          radius: '112%',
          innerRadius: '95%',
          y: parseFloat(payload.steps)
        }],
      }]
    });
  }

  render() {
    const { id, payload, check} = this.props;

    return (
      <MainGraph>
        <StyledHighChart id={id} />
        <BackgroundContainer check={check}>
          <img src="/public/images/NewDashboardV2/dashedImage.png" />
          {/*<RangeContainer>*/}
          {/*  <div>*/}
          {/*    0*/}
          {/*  </div>*/}
          {/*  <div>*/}
          {/*    7000*/}
          {/*  </div>*/}
          {/*</RangeContainer>*/}
          <ContainerInsideChart calories={parseFloat(payload && payload.calories)}>
            <img src="/public/images/NewDashboardV2/personIcon.png" />
            {payload ? parseFloat(payload.steps) : null}
            <p>Steps</p>
          </ContainerInsideChart>
        </BackgroundContainer>
      </MainGraph>
    )
  }
}

HighchartComponent.propTypes = {
  id: PropTypes.string,
  payload: PropTypes.object,
  check: PropTypes.bool
};

export default HighchartComponent;
